export enum SertMqttEnum {
  'Сертификат сервера',
  'Сертификат клиента',
  'Приватный ключ клиента',
}
